import { render } from "./dol-upload-img.vue?vue&type=template&id=b3e81c38"
import script from "./dol-upload-img.vue?vue&type=script&lang=js"
export * from "./dol-upload-img.vue?vue&type=script&lang=js"

import "./dol-upload-img.vue?vue&type=style&index=0&id=b3e81c38&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__